import { StatTableCellProps } from "components/StatsTable/StatTableColumn";
import { StatTableImageColumn } from "./ImageColumn";
import {
  ImageCell,
  ImageCellContents,
  ImageContainer,
  ImageText,
  Image,
} from "./styles";

interface Props<T> extends StatTableCellProps<T, StatTableImageColumn<T>> {}

export function StatTableImageCell<T>({
  stats,
  column,
  columnIdx,
  frozenOffset,
}: Props<T>) {
  const url = column.imageUrlGetter(stats);
  const text = !!column.imageTextGetter
    ? column.imageTextGetter(stats)
    : undefined;

  return (
    <ImageCell
      key={`${columnIdx} image ${url}`}
      highlight={column.highlight}
      frozenWidth={column.frozenWidth}
      frozenOffset={frozenOffset}
      border={column.border}
    >
      <ImageCellContents>
        <ImageContainer>
          <Image
            hasText={text !== undefined}
            width={145}
            height={145}
            src={url}
          />
          <ImageText>{text}</ImageText>
        </ImageContainer>
      </ImageCellContents>
    </ImageCell>
  );
}
